exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-build-version[data-v-ff2cb5ac]{margin-top:1rem;font-size:.75rem;text-align:right;color:var(--fts-default)}", ""]);

// exports
